import { ProductDate } from '../../lib/types/models/product/product-date'
import { ProductDateInput } from '../../lib/types/models/product/product-date-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type ProductDateRequest = ProductDateInput & { productId: number }

export function createProductDate(data: ProductDateRequest): Promise<ProductDate> {
  return restApiClient
    .url(constructApiUrl(API.products.createProductDate.url, null))
    .post<ProductDate, ProductDateRequest>(data)
}
